import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

import FormGroup from "@material-ui/core/FormGroup";
import MuestraAlerta from "./MuestraAlerta";
import InputMask from "react-input-mask";
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  button: {
    marginLeft: theme.spacing(1)
  }
});

class AccountForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      telefono_origen: "", 
      numero_cuenta: "",
      codigo_postal: "", 
      errores: {
        telefono_origen: "",
        numero_cuenta: "",
        codigo_postal: ""
      },
      muestra: false,
      mensajeDialogo: [],
      detalleDialogo: [],
      valoresDetalleDialogo: []
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDialog = this.handleDialog.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    let { errores } = this.state;
    let valorParaEstablecer;

    errores[name] = '';
    if (value.length === 0) {
      errores[name] = 'camporequerido';
    }
    this.setState({
      errores,
      [name]: value.replace(/\s/, "")
    });
    
    if (name === 'numero_cuenta') {
      if (value.length > 7) {
        valorParaEstablecer = value.replace(/\s/g, "");
      } else {
        valorParaEstablecer = '';
      }
    } else if (name === 'telefono_origen') {
      if (value.length > 9) {
        valorParaEstablecer = value.replace(/\s/g, "");
      } else {
        valorParaEstablecer = '';
      }
    } else if (name === 'codigo_postal') {
      if (value.length > 4) {
        valorParaEstablecer = value;
      } else {
        valorParaEstablecer = '';
      }
    }
    this.props.onChangeInput(name, valorParaEstablecer);
  }

  handleDialog = e => {
    this.setState({ muestra: false });
  };

  validaCampos = () => {
    let valido = true;
    const { errores, telefono_origen, codigo_postal } = this.state;
    if (telefono_origen === "") {
      errores.telefono_origen = "Campo es requerido";
      valido = false;
    }
    if (codigo_postal === "") {
      errores.codigo_postal = "Campo es requerido";
      valido = false;
    }
    Object.values(errores).forEach(valor => {
      valor.length > 0 && (valido = false);
    });
    this.setState({ errores });
    return valido;
  };

  render() {
    const { classes, t } = this.props;
    const { errores } = this.state;

    return (
      <form className={classes.container}>
        <MuestraAlerta
          handleDialog={this.handleDialog}
          mostrarDialogo={this.state.muestra}
          tituloDialogo={"No fue posible la operación"}
          mensajeDialogo={this.state.mensajeDialogo}
          detalleDialogo={this.state.detalleDialogo}
          valoresDetalleDialogo={this.state.valoresDetalleDialogo}
        />
        <FormGroup row={false}>
          { this.props.tipoBusqueda === 'teléfono' ? (
            <InputMask
              mask="999 999 9999"
              maskChar=""
              onChange={this.handleChange}
              className={classes.textField}
              value={this.state.telefono_origen}
            >
              {() => (
                <TextField
                  error={errores.telefono_origen.length > 0}
                  name="telefono_origen"
                  label={t('numerotelefono')}
                  margin="dense"
                  variant="outlined"
                  helperText={t(errores.telefono_origen)}
                />
              )}
            </InputMask>
          ) : (
            <InputMask
              mask="999999999"
              maskChar=""
              onChange={this.handleChange}
              className={classes.textField}
              value={this.state.numero_cuenta}
            >
              {() => (
                <TextField
                error={errores.numero_cuenta.length > 0}
                name="numero_cuenta"
                label={t('numerocuenta')}
                margin="dense"
                variant="outlined"
                helperText={t(errores.numero_cuenta)}
                />
              )}
            </InputMask>
          )}
        </FormGroup>
      </form>
    );
  }
}

AccountForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withTranslation('pagos')(withStyles(styles)(AccountForm));
